import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { JsonPatchOperation } from '@core/data/models/json-patch.model';
import { ResultPage } from '@core/data/models/result-page.model';
import { mapResponseWithLocationId } from '@utils/location-header.util';
import { environment } from 'src/environments/environment';
import { CaseType } from '../models/case-type.model';

@Injectable({
  providedIn: 'root',
})
export class CaseTypeService {
  private readonly http = inject(HttpClient);
  protected apiUrl = `${environment.apiUrl}/case-types`;

  loadList(): Observable<CaseType[]> {
    return this.http
      .get<ResultPage<CaseType>>(`${this.apiUrl}`)
      .pipe(map((response) => response.result));
  }

  getById(id: string): Observable<CaseType> {
    return this.http.get<CaseType>(`${this.apiUrl}/${id}`);
  }

  create(caseType: Partial<CaseType>): Observable<CaseType> {
    return this.http
      .post<number>(`${this.apiUrl}`, caseType, {
        observe: 'response',
      })
      .pipe(
        map((response) =>
          mapResponseWithLocationId(response, caseType as CaseType)
        )
      );
  }

  update(id: string, operations: JsonPatchOperation[]): Observable<CaseType> {
    return this.http.patch<CaseType>(`${this.apiUrl}/${id}`, operations);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
